export const navLinks = [
    {
      id: 'home',
      title: 'Home',
    },
    {
      id: "about",
      title: "About Us",
    },
    { 
      id: 'services',
      title : 'Services',
    },
    {
      id: "team",
      title: "Team",
    },
    {
      id: "contact",
      title: "Contact",
    },
  ];